export default customElements.define('w-datalist', class DataList extends wealthify.CustomElementBaseClass {

    constructor() {
        const config = {
            styleSelector: 'c-datalist',
            templateHTML: `
            <div data-root>
                <table class="c-datalist__table" cellspacing="0" data-table aria-hidden="true">
                </table>
                
                <div class="u-display__hidden" aria-live="polite" data-arialivedatalist></div>
            </div>`,
            cacheDom: ['data-table', 'data-arialivedatalist']
        };

        super(config);

        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('items', {type: wealthify.propTypes.Array()}),
            new wealthify.Prop('caption'),
            new wealthify.Prop('collapsemobile', {
                default: false,
                type: wealthify.propTypes.Boolean()
            })
        ];
    }

    get propCallbacks() {
        return {
            items: (value) => {
                this.dom.table.innerHTML = '';

                this.dom.headers = [];
                this.dom.values = [];
                this.dom.tertiarys = [];

                this.ariamessage = '';

                value.forEach((item) => {
                    const row = document.createElement('tr');
                    const header = document.createElement('th');
                    const value = document.createElement('td');
                    const tertiary = document.createElement('td');

                    this.dom.headers.push(header);
                    this.dom.values.push(value);
                    this.dom.tertiarys.push(tertiary);
               
                    row.appendChild(header);
                    
                    if (item.heading === undefined) {
                        row.appendChild(value);
                        row.appendChild(tertiary);
                    }

                    row.classList.add('c-datalist__row');
                    header.classList.add('c-datalist__cell-header');
                    value.classList.add('c-datalist__cell-value');
                    tertiary.classList.add('c-datalist__cell-tertiary');
                    
                    if (item.emphasise){
                        row.classList.add('c-datalist__row--emphasise');
                        header.classList.add('c-datalist__cell--emphasise');
                        value.classList.add('c-datalist__cell--emphasise');
                        tertiary.classList.add('c-datalist__cell--emphasise');
                    }

                    if (item.separator) {
                        row.classList.add('c-datalist__row--separate');
                        header.classList.add('c-datalist__cell--separate');
                        value.classList.add('c-datalist__cell--separate');
                        tertiary.classList.add('c-datalist__cell--separate');
                    }

                    if (item.tertiary !== undefined) {
                        tertiary.classList.add('u-padding__left-mobile--spacing-m');
                    }

                    if (item.heading) {
                        header.classList.add('c-datalist__cell-heading');
                    }

                    header.setAttribute('scope', 'row');
                    header.innerHTML = item.label;
                    value.innerHTML = item.value ?? '';
                    tertiary.innerHTML = item.tertiary ?? '';

                    this.dom.table.appendChild(row);
                    
                    if(item.value === '-'){
                        this.ariamessage = `${item.label} ${item.value}`;    
                    }
                });
                
                this.dom.arialivedatalist.textContent = this.ariamessage;
                
                if (this.caption) {
                    this._updateCaption();
                }
                
                if (this.collapsemobile) {
                    this._updateCollapseMobileClasses();
                }
            },
            
            caption: () => {
                if (!this.items) {
                    this._updateCaption();
                }
            },
            
            collapsemobile: () => {
                this._updateCollapseMobileClasses();
            }
        };
        

    }

    _updateCaption() {
        const caption = document.createElement('caption');

        caption.classList.add('c-datalist__caption');
        caption.innerHTML = this.caption;
        this.dom.table.appendChild(caption);
    }

    _updateCollapseMobileClasses () {
        const itemsNotAdded = [this.dom.headers, this.dom.values, this.dom.tertiarys].some((domGroup) => domGroup === undefined);
        const classListAction = this.collapsemobile ? 'add' : 'remove';

        if (itemsNotAdded) {
            return;
        }
                
        this.dom.headers.forEach((element) => element.classList[classListAction](`${this.styleSelector}__cell-header--collapse-mobile`));
        this.dom.values.forEach((element) => element.classList[classListAction](`${this.styleSelector}__cell-value--collapse-mobile`));
        this.dom.tertiarys.forEach((element) => element.classList[classListAction](`${this.styleSelector}__cell-tertiary--collapse-mobile`));
    }
});